import { createFileRoute } from '@tanstack/react-router';
import { EmployeeOvertimeModule } from '@/modules/ess/overtime';

export const Route = createFileRoute('/(dashboard)/_dashboard/ess/overtime')({
  component: EmployeeOvertimeModule,
});
